import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AdminProvider } from './context/AdminContext';
import AdminPinModal from './components/AdminPinModal';
import AdminDashboard from './components/AdminDashboard';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Botanicals from './pages/Botanicals';
import PlantDetail from './pages/PlantDetail';
import PlantExperiences from './pages/PlantExperiences';

function App() {
  return (
    <AdminProvider>
      <Router>
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex">
          <Navbar />
          <div className="flex-1 pl-0 lg:pl-64 min-h-screen overflow-auto pt-14 lg:pt-0">
            <main className="min-h-full">
              <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 lg:py-8">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/botanicals" element={<Botanicals />} />
                  <Route 
                    path="/botanicals/:id" 
                    element={<PlantDetail key={window.location.search} />} 
                  />
                  <Route path="/plants/:id/experiences" element={<PlantExperiences />} />
                </Routes>
              </div>
            </main>
          </div>
          <Toaster position="bottom-right" />
          <AdminPinModal />
          <AdminDashboard />
        </div>
      </Router>
    </AdminProvider>
  );
}

export default App;
